import * as React from "react";
import { Route, Routes } from "react-router-dom";
import { PrivateRoute } from "./privateRoute";
import { HomePage } from "../components/HomePage"
import SigninCallback from "../components/auth/signinResponse";
import { Header } from "../components/header";
import Commission from "../components/Commission";
import { Breadcrumb } from "../components/Breadcrumb";
import { Menu } from "../components/Menu";
import User from "../components/User";
import { ReactNotifications } from "react-notifications-component";
import Escrow from "../components/Escrow";
import Business from "../components/Business";
import Producer from "../components/Producer";
import InvoiceTab from "../components/Invoice/InvoiceTab";


export const RoutesOnecomm = (
  <div className="vtmn-bg-background-tertiary" style={{ height: '100vh', overflow: 'auto' }}>
    <ReactNotifications />
    <div className="block">
      <Header />
      <Breadcrumb />
    </div>
    <div className="vtmn-flex ">
      <div>
        <Menu />
      </div>
      <div style={{ width: '100%', height: 'calc(100vh - 84px)', overflow: 'auto' }}>
        <Routes>
          <Route path="/auth/code" element={<SigninCallback />} />
          <Route path="/" element={<PrivateRoute component={HomePage} rules={['READER', 'ADMIN']} />} />
          <Route path="/invoice" element={<PrivateRoute component={InvoiceTab} rules={['READER', 'ADMIN']} />} />
          <Route path="/escrow" element={<PrivateRoute component={Escrow} rules={['ADMIN']} />} />
          <Route path="/business" element={<PrivateRoute component={Business} rules={['ADMIN']} />} />
          <Route path="/producer" element={<PrivateRoute component={Producer} rules={['READER', 'ADMIN']} />} />
          <Route path="/commission" element={<PrivateRoute component={Commission} rules={['READER', 'ADMIN']} />} />
          <Route path="/user" element={<PrivateRoute component={User} rules={['ADMIN']} />} />
        </Routes>
      </div>
      
    </div>
  </div>
);